import * as Yup from 'yup';
import styled from '@emotion/styled';
import { Color } from '@sunrun/mui-theme';
import { MIN_DESKTOP_BREAKPOINT } from '../general/constants/_breakpoints';
import { HEADER_HEIGHT } from '../general/constants/_sizes';
import HawaiianHouse from '../../images/SunrunHawaiiSolarHome.jpg';

export const StyledBackground = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const Background = styled.div`
  width: 100%;

  @media only screen and (min-width: ${MIN_DESKTOP_BREAKPOINT}) {
    height: calc(100vh - ${HEADER_HEIGHT});
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    background-image: url(${HawaiianHouse});
    background-repeat: no-repeat;
    background-size: cover;
    &::before {
      content: '';
      position: absolute;
      top: 0px;
      right: 0px;
      bottom: 0px;
      left: 0px;
      background-color: rgba(50, 50, 50, 0.7);
    }
  }
`;

export const Container = styled.div`
  margin: 20px 25px;
  padding: ${props => (props.indivFAQ ? '10px' : '40px 10px 15px')};
  background-color: ${Color.WHITE};
  box-shadow: 0px 15px 33px rgba(178, 173, 166, 0.19);

  @media only screen and (min-width: ${MIN_DESKTOP_BREAKPOINT}) {
    max-width: ${props => (props.customCardWidth ? props.customCardWidth : '650px')};
    margin: ${props => (props.indivFAQ ? '0 auto 24px' : '24px auto')};
  }

  input {
    background-color: transparent;
  }

  h3 {
    text-align: center;
  }
`;

export const Content = styled.div`
  flex: 1 0 auto;
`;

export const ModalContent = styled.div`
  text-align: left;
`;

export const SmallText = styled.div`
  margin: 32px 40px;
  color: ${Color.BLACK_85};

  > div {
    margin-top: 10px;
  }
`;

export const SmallTextCentered = styled(SmallText)`
  text-align: center;
  font-size: 12px;
  color: ${Color.BLACK_45};
  margin-bottom: 20px;
`;

export const MediumText = styled.div`
  margin: 16px 32px;
  color: ${Color.BLACK_85};
  line-height: 24px;
  > div {
    margin-top: 10px;
  }
`;

export const FormattedList = styled.div`
  padding-bottom: 6px;
`;

export const FormattedListTitle = styled.div`
  padding-top: 5px;
  padding-bottom: 5px;
`;

export const IndentedList = styled.div`
  padding-left: 18px;

  > div {
    margin-top: 6px;
  }

  div:last-of-type {
    padding-bottom: 11px;
  }
`;

export const ConditionsText = styled(SmallText)`
  text-align: center;
  font-size: 12px;
  color: ${Color.BLACK_85};
`;

export const ButtonContainer = styled.div`
  text-align: center;
`;

export const InputContainer = styled.div`
  width: 70%;
  margin: auto;
  margin-bottom: 20px;
`;

export const TitleDiv = styled.div`
  color: ${Color.BLACK_85};
  font-size: 24px;
  font-weight: bold;
  line-height: 36px;
  text-align: center;
`;

export const SubTitleDiv = styled.div`
  color: ${Color.BLACK_85};
  font-size: 18px;
  font-weight: bold;
  line-height: 27px;
`;

export const ButtonText = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  text-decoration: underline;
`;

export const digitalSignatureSchema = Yup.object().shape({
  digitalSignature: Yup.string().required('Please enter your first and last name'),
});
